var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFoodAndDrink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20342_8370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 21.5H15.5625C15.0447 21.5 14.625 21.9197 14.625 22.4375C14.625 23.3004 15.3246 24 16.1875 24H22.4375C23.3004 24 24 23.3004 24 22.4375C24 21.9197 23.5803 21.5 23.0625 21.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4062 19.625C15.1474 19.625 14.9375 19.8349 14.9375 20.0938C14.9375 20.3526 15.1474 20.5625 15.4062 20.5625H23.2188C23.4776 20.5625 23.6875 20.3526 23.6875 20.0938C23.6875 19.8349 23.4776 19.625 23.2188 19.625H15.4062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 18.6875H23.0625C23.5803 18.6875 24 18.2678 24 17.75C24 16.1967 22.7408 14.9375 21.1875 14.9375H17.4375C15.8842 14.9375 14.625 16.1967 14.625 17.75C14.625 18.2678 15.0447 18.6875 15.5625 18.6875ZM21.5 16.3438C21.7589 16.3438 21.9688 16.5536 21.9688 16.8125C21.9688 17.0714 21.7589 17.2812 21.5 17.2812C21.2411 17.2812 21.0312 17.0714 21.0312 16.8125C21.0312 16.5536 21.2411 16.3438 21.5 16.3438ZM19.3125 16.3438C19.5714 16.3438 19.7812 16.5536 19.7812 16.8125C19.7812 17.0714 19.5714 17.2812 19.3125 17.2812C19.0536 17.2812 18.8438 17.0714 18.8438 16.8125C18.8438 16.5536 19.0536 16.3438 19.3125 16.3438ZM17.125 16.3438C17.3839 16.3438 17.5938 16.5536 17.5938 16.8125C17.5938 17.0714 17.3839 17.2812 17.125 17.2812C16.8661 17.2812 16.6562 17.0714 16.6562 16.8125C16.6562 16.5536 16.8661 16.3438 17.125 16.3438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 9.875H13.1562C13.3288 9.875 13.4688 9.73509 13.4688 9.5625V8.9375C13.4688 8.41972 13.049 8 12.5312 8H10.6562C10.1385 8 9.71875 8.41972 9.71875 8.9375V9.5625C9.71875 9.73509 9.85866 9.875 10.0312 9.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33403 16.5H13.902C14.1176 15.8921 14.4856 15.3559 14.96 14.9375H8.17525C8.1764 14.9504 8.17722 14.9633 8.17856 14.9763L8.33403 16.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6875 17.75C13.6875 17.6447 13.6921 17.5406 13.7006 17.4375H8.42969L8.52484 18.3701C8.57609 18.8725 8.49519 19.3869 8.29091 19.8578C8.10059 20.2965 8 20.8103 8 21.3438C8 22.0404 8.17097 22.6976 8.48141 23.1943C8.80609 23.7139 9.24553 24 9.71875 24C10.0577 24 10.3789 23.854 10.6562 23.5759C10.9336 23.854 11.2548 24 11.5938 24C11.9327 24 12.2539 23.854 12.5312 23.5759C12.8086 23.854 13.1298 24 13.4688 24C13.6906 24 13.9047 23.9364 14.1033 23.8161C13.8409 23.4206 13.6875 22.9467 13.6875 22.4375C13.6875 21.8684 13.9427 21.3581 14.3443 21.014C14.1301 20.7671 14 20.4454 14 20.0938C14 19.7421 14.1301 19.4204 14.3443 19.1735C13.9427 18.8294 13.6875 18.3191 13.6875 17.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6974 12.074L13.458 11.903C13.1712 11.6982 13 11.3654 13 11.013V10.8125H10.1875V11.013C10.1875 11.3654 10.0163 11.6982 9.72948 11.903L9.49004 12.074C8.83619 12.541 8.39379 13.2343 8.23148 14H14.956C14.7937 13.2343 14.3513 12.541 13.6974 12.074Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20342_8370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFoodAndDrink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/food_and_drink.661c54f2a0daeeeeff0db7f8f51764a8.svg";